import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "activity-filter-bar" }
const _hoisted_2 = ["aria-pressed", "aria-label"]
const _hoisted_3 = {
  class: "activity-time-toggle__label-shell",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "activity-timeline-wrapper" }
const _hoisted_5 = ["aria-busy"]
const _hoisted_6 = {
  key: 0,
  class: "shipment-activity-empty"
}
const _hoisted_7 = {
  key: 1,
  class: "shipment-activity-empty shipment-activity-error"
}
const _hoisted_8 = { class: "timeline-date" }
const _hoisted_9 = { class: "timeline-time" }
const _hoisted_10 = { class: "timeline-context-block" }
const _hoisted_11 = { class: "timeline-context-line timeline-anomaly-heading" }
const _hoisted_12 = { class: "timeline-anomaly-title" }
const _hoisted_13 = { class: "timeline-anomaly-priority" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = {
  key: 1,
  class: "timeline-anomaly-silenced"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "timeline-context-line"
}
const _hoisted_18 = { class: "timeline-context-author" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "timeline-date" }
const _hoisted_21 = { class: "timeline-time" }
const _hoisted_22 = { class: "timeline-message-block" }
const _hoisted_23 = ["onDblclick"]
const _hoisted_24 = { class: "timeline-header-row" }
const _hoisted_25 = { class: "timeline-header" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "timeline-user" }
const _hoisted_28 = {
  key: 0,
  class: "timeline-pill legacy"
}
const _hoisted_29 = {
  key: 1,
  class: "timeline-pill command"
}
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 0,
  class: "timeline-message-attachments"
}
const _hoisted_32 = ["aria-disabled", "title", "onClick"]
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = {
  key: 1,
  class: "timeline-attachment-label"
}
const _hoisted_35 = { class: "timeline-attachment-name" }
const _hoisted_36 = {
  key: 0,
  class: "timeline-message-meta"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 2,
  class: "scan-group-container"
}
const _hoisted_39 = { class: "scan-group-box" }
const _hoisted_40 = {
  key: 0,
  class: "scan-location-header"
}
const _hoisted_41 = ["title", "onClick", "onDblclick"]
const _hoisted_42 = { class: "scan-group" }
const _hoisted_43 = { class: "scan-date" }
const _hoisted_44 = { class: "scan-time" }
const _hoisted_45 = { class: "scan-description" }
const _hoisted_46 = {
  key: 0,
  class: "icon-alert-triangle-16 icon-orange scan-delay-icon",
  "data-tippy-content": "Delayed",
  "data-tippy-placement": "top",
  "aria-label": "Delayed"
}
const _hoisted_47 = {
  key: 1,
  class: "scan-exception"
}
const _hoisted_48 = {
  key: 3,
  class: "shipment-activity-empty"
}
const _hoisted_49 = {
  key: 0,
  class: "shipment-activity-drop-panel"
}
const _hoisted_50 = { class: "shipment-message-progress-slot" }
const _hoisted_51 = ["role", "aria-label"]
const _hoisted_52 = {
  key: 1,
  class: "shipment-activity-notice shipment-activity-error",
  role: "alert"
}
const _hoisted_53 = ["src", "alt"]
const _hoisted_54 = {
  key: 1,
  class: "composer-attachment-label"
}
const _hoisted_55 = ["aria-label", "onClick"]
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = {
  key: 1,
  class: "composer-attachment-label"
}
const _hoisted_58 = {
  class: "composer-attachment-progress-shell",
  "aria-hidden": "true"
}
const _hoisted_59 = {
  key: 0,
  class: "composer-suggestion-list",
  role: "listbox",
  "aria-label": "Message suggestions"
}
const _hoisted_60 = ["onMouseenter", "onMousedown"]
const _hoisted_61 = ["src"]
const _hoisted_62 = {
  key: 1,
  class: "composer-suggestion-file"
}
const _hoisted_63 = {
  key: 2,
  class: "composer-suggestion-file upload"
}
const _hoisted_64 = {
  key: 3,
  class: "composer-suggestion-hash"
}
const _hoisted_65 = { class: "composer-suggestion-line" }
const _hoisted_66 = { class: "composer-suggestion-label" }
const _hoisted_67 = {
  key: 0,
  class: "composer-suggestion-separator"
}
const _hoisted_68 = {
  key: 1,
  class: "composer-suggestion-secondary"
}
const _hoisted_69 = {
  key: 2,
  class: "shipment-activity-notice"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_OverflowMenu = _resolveComponent("OverflowMenu")!
  const _component_MessageComposer = _resolveComponent("MessageComposer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['shipment-activity-pane-root', { 'is-drag-over': _ctx.isDragOver }]),
    onDragenter: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
    onDragover: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
    onDragleave: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"])),
    onDrop: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "activity-time-toggle",
        "aria-pressed": _ctx.timeDisplayMode === 'scan' ? 'true' : 'false',
        "aria-label": `Switch to ${_ctx.timeDisplayMode === 'local' ? 'local' : 'Voltera'} time display`,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTimeDisplayMode && _ctx.toggleTimeDisplayMode(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["activity-time-toggle__track", { 'is-scan': _ctx.timeDisplayMode === 'scan' }]),
          "aria-hidden": "true"
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("span", { class: "activity-time-toggle__thumb" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_Transition, {
            name: _ctx.timeToggleTransitionName,
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("span", {
                key: _ctx.timeDisplayMode,
                class: "activity-time-toggle__label"
              }, _toDisplayString(_ctx.timeToggleLabel), 1 /* TEXT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"])
        ])
      ], 8 /* PROPS */, _hoisted_2),
      _createVNode(_component_Select, {
        modelValue: _ctx.activityFilter,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activityFilter) = $event)),
        class: "activity-filter-select",
        options: _ctx.activityFilterOptions,
        "aria-label": "Filter activity feed",
        compact: ""
      }, null, 8 /* PROPS */, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.showJumpButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "jump-to-bottom",
            id: "jumpToBottom",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToBottom('smooth')))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
            ], -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        ref: "timelineRef",
        class: "activity-timeline scroll-content",
        id: "my-scrollbar",
        "aria-busy": _ctx.isLoading,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTimelineClick && _ctx.handleTimelineClick(...args))),
        onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleTimelineScroll && _ctx.handleTimelineScroll(...args)))
      }, [
        (_ctx.isLoading && _ctx.visibleTimelineItems.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading activity…"))
          : (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
            : (_ctx.visibleTimelineItems.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.visibleTimelineItems, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.key
                  }, [
                    (item.kind === 'message' && item.message.displayType === 'context')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['timeline-item', 'timeline-item-context', { 'timeline-item-anomaly': _ctx.isAnomalyAlertMessage(item.message) }])
                        }, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.dateLabel), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.timeLabel), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.isAnomalyAlertMessage(item.message))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                                      class: "icon-hexagon-asterisk-16 timeline-anomaly-icon",
                                      "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)),
                                    _createElementVNode("span", _hoisted_12, "System " + _toDisplayString(_ctx.getAnomalyTitle(item.message)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_13, "· " + _toDisplayString(_ctx.getAnomalyPriorityLabel(item.message)), 1 /* TEXT */),
                                    (_ctx.isAnomalyActive(item.message))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "timeline-anomaly-dismiss",
                                          disabled: _ctx.dismissingAnomalyMessageId === item.message.id,
                                          onClick: ($event: any) => (_ctx.dismissAnomalyAlert(item.message))
                                        }, _toDisplayString(_ctx.dismissingAnomalyMessageId === item.message.id ? 'Dismissing…' : 'Dismiss'), 9 /* TEXT, PROPS */, _hoisted_14))
                                      : (_ctx.getAnomalyReviewedByLabel(item.message))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Reviewed by " + _toDisplayString(_ctx.getAnomalyReviewedByLabel(item.message)), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", {
                                    class: "timeline-context-text timeline-anomaly-summary",
                                    innerHTML: _ctx.formatAnomalySummaryHtml(item.message)
                                  }, null, 8 /* PROPS */, _hoisted_16)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getAuthorDisplayName(item.message.authorId)), 1 /* TEXT */),
                                  _createElementVNode("span", {
                                    class: "timeline-context-text",
                                    innerHTML: _ctx.formatContextMessageHtml(item.message)
                                  }, null, 8 /* PROPS */, _hoisted_19)
                                ]))
                          ])
                        ], 2 /* CLASS */))
                      : (item.kind === 'message')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(['timeline-item', 'user-note', { 'legacy-note': item.message.legacy, 'command-note': item.message.isCommand }])
                          }, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(item.dateLabel), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(item.timeLabel), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", {
                                class: _normalizeClass(['timeline-content', { editable: _ctx.canEditMessage(item.message), editing: _ctx.editingMessageId === item.message.id }]),
                                onDblclick: ($event: any) => (_ctx.startEditingMessage(item.message))
                              }, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("img", {
                                      src: _ctx.getAuthorAvatar(item.message.authorId),
                                      class: "timeline-avatar"
                                    }, null, 8 /* PROPS */, _hoisted_26),
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getAuthorDisplayName(item.message.authorId)), 1 /* TEXT */),
                                    (item.message.legacy)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Legacy"))
                                      : (item.message.isCommand)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Command"))
                                        : _createCommentVNode("v-if", true)
                                  ]),
                                  (_ctx.canShowMessageActions(item.message))
                                    ? (_openBlock(), _createBlock(_component_OverflowMenu, {
                                        key: `${item.message.id}-${_ctx.messageMenuRenderKey}`,
                                        class: "action-menu-wrapper timeline-action-menu",
                                        "button-label": "Message actions",
                                        portal: true,
                                        placement: "top",
                                        "trigger-class": ['action-menu-trigger', 'timeline-action-trigger'],
                                        options: _ctx.getMessageMenuOptions(item.message),
                                        onSelect: ($event: any) => (_ctx.handleMessageMenuSelect($event, item.message))
                                      }, {
                                        trigger: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                          _createElementVNode("i", { class: "material-icons" }, "more_vert", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["options", "onSelect"]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", {
                                  class: "timeline-message",
                                  innerHTML: _ctx.formatMessageHtml(item.message)
                                }, null, 8 /* PROPS */, _hoisted_30),
                                (item.message.attachments && item.message.attachments.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.message.attachments, (attachment) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: `${item.message.id}-${attachment.fileId}`,
                                          type: "button",
                                          class: _normalizeClass([
                        'timeline-attachment-card',
                        `is-${_ctx.getAttachmentPreviewKind(attachment)}`,
                        { 'is-removed': _ctx.isMessageAttachmentRemoved(attachment) }
                      ]),
                                          "aria-disabled": _ctx.isMessageAttachmentRemoved(attachment) ? 'true' : 'false',
                                          title: _ctx.getMessageAttachmentStatusLabel(attachment),
                                          onClick: _withModifiers(($event: any) => (_ctx.openMessageAttachment(attachment)), ["stop"])
                                        }, [
                                          (!_ctx.isMessageAttachmentRemoved(attachment) && _ctx.attachmentPreviewUrls[attachment.fileId])
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.attachmentPreviewUrls[attachment.fileId],
                                                alt: `${attachment.displayName} preview`,
                                                class: "timeline-attachment-image",
                                                loading: "lazy"
                                              }, null, 8 /* PROPS */, _hoisted_33))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.isMessageAttachmentRemoved(attachment) ?
                        'REMOVED' :
                        _ctx.getAttachmentPreviewLabel(attachment)), 1 /* TEXT */)),
                                          _createElementVNode("span", _hoisted_35, _toDisplayString(attachment.displayName), 1 /* TEXT */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_32))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_23),
                              (item.message.edited)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    (item.message.edited)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(edited)"))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ], 2 /* CLASS */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              (item.location)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['timeline-location', { editable: Boolean(item.waypointId), verified: item.verified, 'has-coords': Boolean(item.coords) }]),
                                      title: item.waypointId ? 'Click to view on map • Double-click to edit waypoint' : (item.coords ? 'Click to view on map' : ''),
                                      onClick: ($event: any) => (_ctx.handleLocationClick(item.coords)),
                                      onDblclick: _withModifiers(($event: any) => (_ctx.handleWaypointEdit(item.waypointId)), ["prevent","stop"])
                                    }, _toDisplayString(item.location), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_41)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_42, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.scans, (scan) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: scan.key,
                                    class: "scan-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_43, _toDisplayString(scan.dateLabel), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_44, _toDisplayString(scan.timeLabel), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_45, [
                                      (scan.delayed)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", null, _toDisplayString(scan.description), 1 /* TEXT */),
                                      (scan.exceptionDescription)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(scan.exceptionDescription), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ]))
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.activityEmptyLabel), 1 /* TEXT */))
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
    ]),
    (_ctx.isDragOver)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("div", { class: "shipment-activity-drop-copy" }, [
            _createElementVNode("span", null, "Drop files to attach"),
            _createElementVNode("small", null, "Supported: images, PDF, XLSX, CSV, TXT. Max 10 MB each. Up to 3 attachments per message.")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_50, [
      _createVNode(_Transition, { name: "shipment-message-progress" }, {
        default: _withCtx(() => [
          (_ctx.isMessageActionPending || _ctx.messageActionError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["shipment-message-progress", { 'is-error': _ctx.messageActionError }]),
                role: _ctx.isMessageActionPending ? 'progressbar' : undefined,
                "aria-label": _ctx.isMessageActionPending ? 'Updating message' : undefined
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("span", null, null, -1 /* CACHED */)
              ]))], 10 /* CLASS, PROPS */, _hoisted_51))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    (_ctx.messageActionError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.messageActionError), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_MessageComposer, {
      ref: "composerRef",
      modelValue: _ctx.draft,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.draft) = $event)),
      placeholder: "Add interaction notes",
      "avatar-url": _ctx.currentUserAvatar,
      sending: _ctx.isSending,
      "send-disabled": _ctx.isSendDisabled,
      "is-editing": _ctx.isEditing,
      disabled: _ctx.isSending,
      "force-expanded": _ctx.forceComposerExpanded,
      "has-attachments": _ctx.draftAttachments.length > 0 || _ctx.uploadingDraftAttachments.length > 0,
      "can-attach": _ctx.canAttachFiles,
      "highlight-html": _ctx.composerHighlightHtml,
      "plus-menu-key": _ctx.composerMenuRenderKey,
      "plus-menu-options": _ctx.composerMenuOptions,
      onSubmit: _ctx.submitMessage,
      onCancel: _ctx.cancelEditingMessage,
      onMention: _ctx.handleComposerMentionAction,
      onLink: _ctx.handleComposerShipmentLinkAction,
      onAttach: _ctx.handleComposerPaperclipAction,
      onUpload: _ctx.handleComposerMenuUpload,
      onInput: _ctx.handleComposerInput,
      onFocus: _ctx.handleComposerFocus,
      onBlur: _ctx.handleComposerBlur,
      onKeydown: _ctx.handleComposerKeydown,
      onSelectionChange: _ctx.handleComposerSelectionChange,
      onPlusOpen: _ctx.handleComposerPlusMenuOpen
    }, {
      attachments: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draftAttachments, (attachment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `draft-${attachment.fileId}`,
            class: _normalizeClass(['composer-attachment-card', `is-${_ctx.getAttachmentPreviewKind(attachment)}`])
          }, [
            (_ctx.attachmentPreviewUrls[attachment.fileId])
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.attachmentPreviewUrls[attachment.fileId],
                  alt: `${attachment.displayName} preview`,
                  class: "composer-attachment-image",
                  loading: "lazy"
                }, null, 8 /* PROPS */, _hoisted_53))
              : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.getAttachmentPreviewLabel(attachment)), 1 /* TEXT */)),
            _createElementVNode("button", {
              type: "button",
              class: "composer-attachment-remove",
              "aria-label": `Remove ${attachment.displayName}`,
              onClick: _withModifiers(($event: any) => (_ctx.removeDraftAttachment(attachment.fileId)), ["stop"])
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("i", { class: "material-icons" }, "close", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_55)
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadingDraftAttachments, (attachment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: attachment.key,
            class: _normalizeClass(['composer-attachment-card', 'uploading', `is-${attachment.previewKind}`])
          }, [
            (attachment.previewUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: attachment.previewUrl,
                  alt: `${attachment.displayName} preview`,
                  class: "composer-attachment-image",
                  loading: "lazy"
                }, null, 8 /* PROPS */, _hoisted_56))
              : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(attachment.previewLabel), 1 /* TEXT */)),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", {
                class: "composer-attachment-progress-bar",
                style: _normalizeStyle({ width: `${attachment.progressPercent}%` })
              }, null, 4 /* STYLE */)
            ])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      suggestions: _withCtx(() => [
        (_ctx.composerSuggestions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.composerSuggestions, (suggestion, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: suggestion.key,
                  type: "button",
                  class: _normalizeClass(['composer-suggestion-item', { active: index === _ctx.highlightedSuggestionIndex, shipment: suggestion.kind === 'shipment' }]),
                  onMouseenter: ($event: any) => (_ctx.highlightedSuggestionIndex = index),
                  onMousedown: _withModifiers(($event: any) => (_ctx.applyComposerSuggestion(index)), ["prevent"])
                }, [
                  (suggestion.kind === 'mention')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: suggestion.avatar,
                        class: "composer-suggestion-avatar"
                      }, null, 8 /* PROPS */, _hoisted_61))
                    : (suggestion.kind === 'file')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(suggestion.previewLabel), 1 /* TEXT */))
                      : (suggestion.kind === 'file-upload')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "material-icons" }, "upload_file", -1 /* CACHED */)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_64, "#")),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", _hoisted_66, _toDisplayString(suggestion.label), 1 /* TEXT */),
                    (suggestion.secondary)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, "›"))
                      : _createCommentVNode("v-if", true),
                    (suggestion.secondary)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(suggestion.secondary), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_60))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "avatar-url", "sending", "send-disabled", "is-editing", "disabled", "force-expanded", "has-attachments", "can-attach", "highlight-html", "plus-menu-key", "plus-menu-options", "onSubmit", "onCancel", "onMention", "onLink", "onAttach", "onUpload", "onInput", "onFocus", "onBlur", "onKeydown", "onSelectionChange", "onPlusOpen"]),
    _createElementVNode("input", {
      ref: "attachmentInputRef",
      type: "file",
      class: "composer-hidden-input",
      multiple: "",
      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleAttachmentInputChange && _ctx.handleAttachmentInputChange(...args)))
    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
    (_ctx.noticeMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.noticeMessage), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}